import React from "react";
import DevelopBannerSection from "../components/Homepage/DevelopPageComponents/DevelopBannerSection";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HealthSliderCard from "../components/HealthcarePageComponent/HealthSliderCard";
import IndusExpert from "../components/IndustriesPageComponents/IndusExpert";
import { Accodion } from "../components/Accordion/AccordionItem";
import FaqVideo from "../components/FaqVideo/FaqVideo";
import TransparentRoundedBtn from "../components/CTA/TransparentRoundedBtn";
import {
  arvindprofileImg,
  float1,
  float2,
  mouseSlide10,
  mouseSlide11,
  mouseSlide12,
  mouseSlide14,
  mouseSlide15,
  mouseSlide9,
} from "../components";
import DevDiff from "../components/Homepage/DevelopPageComponents/DevDiff";
import HealthCareTabSection from "../components/HealthcarePageComponent/HealthCareTabSection";
import HealthcareTabs from "../components/Tabs/HealthcareTabs";
import ExpertButton from "../components/CTA/ExpertButton";
import ScrollingSlide from "../components/MouseScrollingComponent/ScrollingSlide";
function SocialNetwork() {
  var settings = {
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    speed: 800,
    adaptiveHeight: false,
    infinite: true,
    useTransform: true,
    cssEase: "cubic-bezier(0.77, 0, 0.18, 1)",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <section id="healthCare" className="healthCare socialNetworkBg">
      <div className="devTopSection">
        <DevelopBannerSection
          line1="Social Networking"
          line2="API Integration"
          line3="Development"
          BannerPara="At Version Next Technologies, we specialize in offering proficient services for integrating social networking APIs. Our aim is to empower business websites and mobile apps, allowing them to harness the influential capabilities of social media directly within their own platforms."
        />
        <div className="shapeSvg">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15002 2408">
            <g id="Layer_x0020_1">
              <metadata id="CorelCorpID_0Corel-Layer" />
              <path
                className="fil0"
                d="M14999.66 160.41l0 2250.5 -15002 0 0 -2408.48c4.48,15.46 34.05,38.31 47.09,51.36 18.3,18.3 33.31,33.31 51.61,51.61l377.15 322.94c339.34,254.69 723.38,451.6 1129.12,576.25 740.24,227.38 1518.28,209.44 2250.74,-34.78 297.55,-99.2 684.02,-289.57 933.07,-476.11 87.62,-65.63 227.27,-165.69 307.34,-240.17 31.42,-29.23 114.35,-99.39 131.22,-124.58 20,4.66 99.59,47.55 124.17,59.83 42.41,21.2 81.55,40.72 122.67,61.33l125.61 58.39c133.82,59.52 249.76,112.63 391.76,169.22 238.34,95 587.91,216.82 832.54,284.94 200.63,55.86 382.28,106.97 590.69,154.3 1557.59,353.7 3775.68,425.94 5382.01,17.95 25.54,-6.48 49.29,-10.39 73.59,-16.17l373.43 -93.31c198.88,-54.19 343.18,-97.87 536.61,-159.02l312.66 -109.2c47.88,-17.88 90.5,-33.57 136.53,-51.96 82.88,-33.12 316.41,-125.5 392.57,-163.92l128.78 -59.7c23.6,-10.77 225.99,-115.13 251.04,-121.22z"
              />
            </g>
          </svg>
        </div>
      </div>
      <div className="healthServicesSliderWrap">
        <div className="container">
          <div className="row sectionFlexHeading">
            <div className="col-md-6 col-12">
              <div className="sectionTitle">
                <h2>Services for Integrating Social Networking APIs</h2>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <p className="sectionPara">
                The integration of Social Networking APIs plays a vital role in
                enabling websites and mobile applications to swiftly link with
                social media platforms. This facilitates content sharing and the
                implementation of social login functionalities.
              </p>
            </div>
          </div>
          <div className="healthServicesSlider">
            <Slider {...settings} className="slider-with-gap">
              <div className="slide-item">
                <HealthSliderCard
                  cardTitle="E-commerce Platforms"
                  cardPara="Allow users to register and log in to your e-commerce platform using their social media profiles, making the process more convenient and reducing friction. Leverage user social activity data to provide personalized product recommendations, increasing the likelihood of conversions."
                  cardLink=""
                  btnName="Get consultation"
                />
              </div>
              <div className="slide-item">
                <HealthSliderCard
                  cardTitle="Content Sharing Apps"
                  cardPara="Integrate social networking APIs to enable users to share images, videos, articles, or other content directly from your app to their social media profiles. Create an in-app feed that aggregates content shared by users on their connected social networks, enhancing engagement and encouraging content creation."
                  cardLink=""
                  btnName="Leave a request"
                />
              </div>
              <div className="slide-item">
                <HealthSliderCard
                  cardTitle="Event Management Platforms"
                  cardPara="Integrate social networking APIs to allow attendees to share event details, RSVPs, and experiences on their social media accounts, promoting the event organically. Display real-time social media posts related to the event using event-specific hashtags, creating an engaging atmosphere and fostering interaction among attendees."
                  cardLink=""
                  btnName="Order an estimate"
                />
              </div>
              <div className="slide-item">
                <HealthSliderCard
                  cardTitle="Dating Apps"
                  cardPara="Import user profile information and photos from social media platforms, simplifying the setup process and ensuring authenticity. Highlight mutual interests and activities from user's social profiles to improve match recommendations and conversation starters."
                  cardLink=""
                  btnName="Share your idea"
                />
              </div>
            </Slider>
          </div>
        </div>
      </div>
      <section id="healthCareTabSection">
        <div className="container">
          <HealthCareTabSection
            tabSectionTitle1="We Provide"
            tabSectionTitle2="Social Network"
            tabSectionTitle3="Solutions"
            tabSectionPara="In the digital age, social networking has become an integral part of our lives, shaping the way we connect, communicate, and collaborate. Businesses, communities, and individuals all benefit from the power of social networks to share information, build relationships, and drive engagement."
          />
          <HealthcareTabs
            tabTitle1="Customized Social Media Platforms"
            tabTitle2="White-label Social Network Software"
            tabTitle3="Mobile-First Social Apps"
            tabTitle4="Community Management Tools"
            tabContentTitle11="Customized Social Media Platforms"
            contentList11="Tailored user interface and features to match your unique brand identity and goals."
            contentList12="Customizable user profiles, groups, and content categories for a personalized experience."
            contentList13="Advanced search and discovery functionalities for easy content exploration."
            
            tabContentTitle22="White-label Social Network Software"
            contentList21="Branded social network platform with your logo, color scheme, and design elements."
            contentList22="Quick deployment and setup, saving you time and resources."
            contentList23="Ongoing updates and support to ensure a smooth user experience."
            
            tabContentTitle33="Mobile-First Social Apps"
            contentList31="Intuitive and responsive app design for seamless mobile user experiences."
            contentList32="Real-time notifications, messaging, and activity feeds to keep users engaged."
            contentList33="Cross-platform compatibility for iOS and Android devices."
            
            tabContentTitle44="Community Management Tools"
            contentList41="Content moderation features to ensure a safe and respectful environment."
            contentList42="User reporting and blocking functionalities to manage inappropriate behavior."
            contentList43="Analytics dashboard to track community health, engagement trends, and user demographics."
            
          />
        </div>
      </section>
      <section
        className="mouseScrollingSliderSection"
        id="mouseScrollingSliderSection"
      >
        <div className="container">
          <div className="sectionTitle">
            <h2>
              {" "}
              Work <span className="textGrade">Portfolio</span>
            </h2>
            <ExpertButton
              rText="Get Project Quote"
              rName="rAnimeBtn qouteBtn"
            />
          </div>
        </div>
        <ScrollingSlide
          scrollSliderImg1={mouseSlide9}
          scrollSliderImg2={mouseSlide10}
          scrollSliderImg3={mouseSlide11}
          scrollSliderImg4={mouseSlide12}
          scrollSliderImg6={mouseSlide14}
          scrollSliderImg7={mouseSlide15}
        />
      </section>
      <section className="IndusExpertSection">
        <IndusExpert
          cName="Version Next Technologies"
          cSecTitle="Why Hire Version Next Technologies For Social Networking Solutions?"
          profileName="Mr. Arvind Baraskar"
          designation="Buisness Head"
          cardTitle1="Innovation"
          cardData1="Evaluate if the company is up-to-date with the latest trends and technologies in the social networking space. Innovation is crucial in a rapidly evolving field."
          cardTitle2="Expertise"
          cardData2="Look into the company's expertise and track record in developing social networking solutions. Check their portfolio and case studies to see if they have successfully delivered similar projects in the past."
          cardTitle3="Communication"
          cardData3="Effective communication between you and the development team is essential throughout the project. Ensure that the company is responsive and transparent in their communication."
          cardTitle4="Security and Privacy"
          cardData4="Given the sensitive nature of user data on social networking platforms, security and privacy should be top priorities. Check if the company follows best practices in securing user information."
          profileImg={arvindprofileImg}
          facebookLink="https://www.facebook.com/arvindv.baraskar"
          facebookIcon="fab fa-facebook-square"
          twiiterLink="https://twitter.com/ArvindBaraskar"
          twitterIcon="fab fa-twitter-square"
          linkdinLink="https://www.linkedin.com/in/arvindbaraskar/"
          linkdinIcon="fab fa-linkedin"
        />
      </section>
      <section className="whatMakesSection" id="whatMakesSection">
        <DevDiff
          float1={float1}
          float2={float2}
          Char1="What Makes"
          Char2="us"
          Char3="Different?"
          diffDescription="At Version Next Technologies, We thrive on innovation. Our teams are constantly exploring new technologies, methodologies, and ideas to bring fresh, creative solutions to the table. This drive for innovation ensures that our clients receive cutting-edge products that keep them ahead of the curve."
        />
      </section>
      <section className="commonFaq">
        <div className="container">
          <div className="sectionTitle">
            <h2>
              Frequently Asked <span className="textGrade">Questions</span>
            </h2>

            <p>
              Singling out common points and possible difficulties which can be
              encountered in EHR, EMR, and Patient Portal software development
            </p>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-6 col-12">
              <Accodion />
            </div>
            <div className="col-md-12 col-lg-6 col-12">
              <FaqVideo />
            </div>
          </div>
          <div className="readMoreBtnWrap">
            <TransparentRoundedBtn
              rText="Read More"
              rLink="/faqs"
              rName="rAnimeBtn readMoretBtn"
            />
          </div>
        </div>
      </section>
    </section>
  );
}

export default SocialNetwork;
